(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nf-design-dit-eget"] && !Shopify.designMode) return;
  try {
    
  function initFrameHeroCarousels(root) {
    root.querySelectorAll('[data-nf-frame-carousel]').forEach((carousel) => {
      if (carousel.dataset.nfReady === 'true') return;
      carousel.dataset.nfReady = 'true';
      const slides = [...carousel.querySelectorAll('[data-nf-frame-slide]')];
      const dots = [...carousel.querySelectorAll('[data-nf-frame-dot]')];
      const autoplayDelay = 7000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const pauseReasons = new Set();
      let active = 0;
      let autoplayTimer = null;
      let touchStart = null;
      const clearAutoplay = () => {
        if (autoplayTimer !== null) window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      };
      const scheduleAutoplay = () => {
        clearAutoplay();
        if (reducedMotion || pauseReasons.size > 0 || document.hidden) return;
        autoplayTimer = window.setTimeout(() => show(active + 1), autoplayDelay);
      };
      const pauseAutoplay = (reason) => {
        pauseReasons.add(reason);
        clearAutoplay();
      };
      const resumeAutoplay = (reason) => {
        pauseReasons.delete(reason);
        scheduleAutoplay();
      };
      const show = (next) => {
        active = (next + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const selected = index === active;
          slide.classList.toggle('is-active', selected);
          if (selected) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
          if (selected) slide.querySelector('img').loading = 'eager';
        });
        dots.forEach((dot, index) => {
          const selected = index === active;
          dot.classList.toggle('is-active', selected);
          if (selected) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        scheduleAutoplay();
      };
      carousel.querySelector('[data-nf-frame-prev]').addEventListener('click', () => show(active - 1));
      carousel.querySelector('[data-nf-frame-next]').addEventListener('click', () => show(active + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      carousel.addEventListener('mouseenter', () => pauseAutoplay('hover'));
      carousel.addEventListener('mouseleave', () => resumeAutoplay('hover'));
      carousel.addEventListener('focusin', () => pauseAutoplay('focus'));
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) resumeAutoplay('focus');
      });
      carousel.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        touchStart = { x: touch.clientX, y: touch.clientY };
        pauseAutoplay('touch');
      }, { passive: true });
      carousel.addEventListener('touchend', (event) => {
        if (touchStart) {
          const touch = event.changedTouches[0];
          const dx = touch.clientX - touchStart.x;
          const dy = touch.clientY - touchStart.y;
          touchStart = null;
          if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy) * 1.3) show(active + (dx < 0 ? 1 : -1));
        }
        resumeAutoplay('touch');
      }, { passive: true });
      carousel.addEventListener('touchcancel', () => {
        touchStart = null;
        resumeAutoplay('touch');
      }, { passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearAutoplay();
        else scheduleAutoplay();
      });
      scheduleAutoplay();
    });
  }
  initFrameHeroCarousels(document);
  document.addEventListener('shopify:section:load', (event) => initFrameHeroCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
